var map = {
	"./account/account.module": [
		"./src/app/account/account.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"default~account-account-module~clipboards-clipboards-module~documents-documents-module~educationalre~5b94a73e",
		"account-account-module"
	],
	"./account/login/login.module": [
		"./src/app/account/login/login.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"account-login-login-module"
	],
	"./appointments/requestappointments.module": [
		"./src/app/appointments/requestappointments.module.ts",
		"appointments-requestappointments-module"
	],
	"./clinical/clinical.module": [
		"./src/app/clinical/clinical.module.ts",
		"clinical-clinical-module"
	],
	"./clipboards/clipboards.module": [
		"./src/app/clipboards/clipboards.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"default~account-account-module~clipboards-clipboards-module~documents-documents-module~educationalre~5b94a73e",
		"clipboards-clipboards-module"
	],
	"./documents/documents.module": [
		"./src/app/documents/documents.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"default~account-account-module~clipboards-clipboards-module~documents-documents-module~educationalre~5b94a73e",
		"documents-documents-module"
	],
	"./educationalresources/educationalresources.module": [
		"./src/app/educationalresources/educationalresources.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"default~account-account-module~clipboards-clipboards-module~documents-documents-module~educationalre~5b94a73e",
		"educationalresources-educationalresources-module"
	],
	"./financials/financials.module": [
		"./src/app/financials/financials.module.ts",
		"common",
		"financials-financials-module"
	],
	"./forms/patientforms.module": [
		"./src/app/forms/patientforms.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"default~account-account-module~clipboards-clipboards-module~documents-documents-module~educationalre~5b94a73e",
		"forms-patientforms-module"
	],
	"./immunotherapy/immunotherapy.module": [
		"./src/app/immunotherapy/immunotherapy.module.ts",
		"default~account-account-module~account-login-login-module~clipboards-clipboards-module~documents-doc~363bf40c",
		"common",
		"immunotherapy-immunotherapy-module"
	],
	"./messageboard/messageboard.module": [
		"./src/app/messageboard/messageboard.module.ts",
		"messageboard-messageboard-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;